import type { ExpressCheckoutOptions } from '../typings/configuration.types';

export const shouldEnforceAllocationExpiry = (
    allocationResult: Date | undefined,
    expressCheckoutOptions?: ExpressCheckoutOptions | null,
): allocationResult is Date => Boolean(allocationResult && expressCheckoutOptions?.useAllocationExpirationTimer);
